@if (expiredToken) {
  <section class="no-auth-page centered">
    <div class="icon"><i class="fa-solid fa-circle-exclamation"></i></div>
    <p>This password reset link has expired.</p>
    <button
      ht-button-primary
      appearance="minimal"
      [fullWidth]="true"
      routerLink="/reset-pwd"
    >
      Try resetting your password again
    </button>
  </section>
}
